module.exports = __webpack_public_path__ + "aa989b4dcfa9f1b44492d4b7c1f363f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/MyriadPro-BoldCond.ttf
// module id = 159
// module chunks = 0